import type React from "react";

export const Icons = {
	Heart: (props: React.SVGProps<SVGSVGElement>) => (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			{...props}
			width="24"
			height="24"
			viewBox="0 0 24 24"
		>
			<path
				stroke="#878787"
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeWidth="1.5"
				fill="none"
				d="M16.111 3C19.633 3 22 6.353 22 9.48 22 15.814 12.178 21 12 21S2 15.814 2 9.48C2 6.352 4.367 3 7.889 3 9.91 3 11.233 4.024 12 4.924 12.767 4.024 14.089 3 16.111 3"
			></path>
		</svg>
	),
	ActiveHeart: (props: React.SVGProps<SVGSVGElement>) => (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			{...props}
			width="24"
			height="24"
			viewBox="0 0 24 24"
		>
			<path
				stroke="#F24A61"
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeWidth="1.5"
				fill="#F24A61"
				d="M16.111 3C19.633 3 22 6.353 22 9.48 22 15.814 12.178 21 12 21S2 15.814 2 9.48C2 6.352 4.367 3 7.889 3 9.91 3 11.233 4.024 12 4.924 12.767 4.024 14.089 3 16.111 3"
			></path>
		</svg>
	),
	Point: (props: React.SVGProps<SVGSVGElement>, className?: string) => (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			{...props}
			width="24"
			height="24"
			fill="none"
			viewBox="0 0 24 24"
			className={className ? className : ""}
		>
			<path
				stroke="#878787"
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeWidth="1.5"
				d="M12 13a3 3 0 1 0 0-6 3 3 0 0 0 0 6"
			></path>
			<path
				stroke="#878787"
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeWidth="1.5"
				d="M12 22c4-4 8-7.582 8-12a8 8 0 1 0-16 0c0 4.418 4 8 8 12"
			></path>
		</svg>
	),
	ArrowLeft: (props: React.SVGProps<SVGSVGElement>, className?: string) => (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			{...props}
			width={props.width || "24"}
			height={props.width || "24"}
			fill="none"
			viewBox="0 0 24 24"
			className={className ? className : ""}
		>
			<path
				stroke="#878787"
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeWidth="1.5"
				d="M15 19l-7-7 7-7"
			></path>
		</svg>
	),
	ArrowRight: (props: React.SVGProps<SVGSVGElement>, className?: string) => (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			{...props}
			width="24"
			height="24"
			fill="none"
			viewBox="0 0 24 24"
			className={className ? className : ""}
		>
			<path
				stroke="#878787"
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeWidth="1.5"
				d="M9 5l7 7-7 7"
			></path>
		</svg>
	),
	Fullscreen: (props: React.SVGProps<SVGSVGElement>, className?: string) => (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			{...props}
			width="24"
			height="24"
			fill="none"
			viewBox="0 0 24 24"
			className={className ? className : ""}
		>
			<path
				stroke="#878787"
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeWidth="1.5"
				d="M15 3h6v6M9 21H3v-6M21 3l-7 7M3 21l7-7"
			></path>
		</svg>
	),
	Close: (props: React.SVGProps<SVGSVGElement>, className?: string) => (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			{...props}
			width="24"
			height="24"
			fill="none"
			viewBox="0 0 24 24"
			className={className ? className : ""}
		>
			<path
				stroke="#878787"
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeWidth="1.5"
				d="M18 6L6 18M6 6l12 12"
			></path>
		</svg>
	),
	TotalArea: (props: React.SVGProps<SVGSVGElement>, className?: string) => (
		<svg
			width="45"
			height="45"
			{...props}
			className={className ? className : ""}
			viewBox="0 0 45 45"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M1.45899 0.490437C0.978006 0.782791 0.453394 1.26623 0.292883 1.56486C0.0939579 1.93446 0.000943793 8.62229 0.000943793 22.5376C0.000943793 44.9765 -0.0950883 43.6944 1.65023 44.5922C2.33234 44.9429 5.2424 45 22.5 45C39.7576 45 42.6677 44.9429 43.3498 44.5922C45.0954 43.6941 44.9991 44.985 44.9991 22.4557C44.9991 2.47522 44.9851 1.92627 44.4596 1.26158C43.5632 0.127656 42.6778 -0.0634241 38.7092 0.0192866C35.5681 0.085073 34.9996 0.164508 34.7406 0.573694C34.5205 0.921734 34.5205 1.18106 34.7406 1.5291C34.9999 1.93883 35.5662 2.01717 38.7177 2.07996C41.7767 2.14083 42.4498 2.22982 42.7354 2.6098C43.1829 3.2057 43.2397 41.4601 42.7944 42.2883C42.5176 42.8028 42.0028 42.8162 22.5 42.8162C2.99716 42.8162 2.48242 42.8028 2.20558 42.2883C1.76026 41.4604 1.81706 3.20706 2.26457 2.60543C2.57763 2.18451 3.85651 2.13837 16.9825 2.07559C30.3308 2.01171 31.3792 1.97268 31.6604 1.5291C31.8813 1.18078 31.8813 0.922007 31.6604 0.573694C31.3792 0.130113 30.3245 0.0910781 16.8453 0.0274754C2.87973 -0.038584 2.30024 -0.0211139 1.45899 0.490437ZM3.85185 4.30905C3.69573 4.59949 3.56787 6.36563 3.56787 8.23385C3.56787 11.8933 3.74018 12.3727 4.99326 12.1961C5.5862 12.1123 5.63421 11.9575 5.7629 9.71418L5.90009 7.32158L10.9152 12.3757C13.6735 15.1553 16.149 17.4298 16.4165 17.4298C17.0097 17.4298 17.5612 16.9179 17.5612 16.3679C17.5612 16.1441 15.2556 13.6556 12.4374 10.8377L7.31368 5.71459L9.75922 5.63488C11.8582 5.56664 12.2179 5.48584 12.2989 5.06464C12.5129 3.95173 11.9326 3.78112 7.93405 3.78112C4.45987 3.78112 4.11169 3.82616 3.85185 4.30905ZM32.9374 4.17748C32.7554 4.39558 32.6869 4.82552 32.7851 5.13288C32.9467 5.63952 33.1857 5.69193 35.3363 5.69193H37.7091L32.5738 10.8265C29.7496 13.6504 27.4388 16.054 27.4388 16.1675C27.4388 16.2808 27.5667 16.6114 27.7228 16.9018C28.3366 18.0426 29.0919 17.5256 34.2129 12.4576L39.2371 7.48563V9.43275C39.2371 10.5036 39.312 11.5739 39.4036 11.8114C39.5998 12.3203 40.6326 12.3836 41.1029 11.9157C41.56 11.4609 41.56 4.56346 41.1029 4.10869C40.5879 3.59632 33.3712 3.65719 32.9374 4.17748ZM11.0727 32.2175L5.78649 37.4512L5.7061 35.152C5.63037 32.9867 5.58894 32.8475 4.99326 32.7635C3.74018 32.5868 3.56787 33.0662 3.56787 36.7257C3.56787 38.5939 3.69573 40.36 3.85185 40.6505C4.11169 41.1331 4.4596 41.1784 7.91265 41.1784C11.8039 41.1784 12.348 41.0389 12.348 40.0415C12.348 39.3069 11.4744 38.9946 9.41927 38.9946H7.55185L12.6937 33.8736C16.7619 29.8222 17.8356 28.6028 17.8356 28.0339C17.8356 27.3657 17.4092 26.9838 16.6631 26.9838C16.4955 26.9838 13.9797 29.339 11.0727 32.2175ZM27.5074 27.1645C26.4999 27.5691 27.2972 28.6367 32.4256 33.7494L37.6866 38.9946L35.924 38.9984C33.6867 39.0031 32.987 39.1939 32.7758 39.8561C32.4147 40.9876 33.0276 41.1784 37.0207 41.1784C39.5738 41.1784 40.879 41.0736 41.1029 40.8508C41.4494 40.5061 41.5872 33.9817 41.2656 33.1481C41.0461 32.5786 39.6231 32.5786 39.4036 33.1481C39.312 33.3856 39.2371 34.4562 39.2371 35.5273V37.475L33.9394 32.2292C28.9454 27.2846 28.3588 26.8228 27.5074 27.1645Z"
				fill="#A7A7A7"
			/>
		</svg>
	),
	LiveArea: (props: React.SVGProps<SVGSVGElement>, className?: string) => (
		<svg
			width="45"
			height="45"
			{...props}
			className={className ? className : ""}
			viewBox="0 0 45 45"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M0.348014 0.384603C0.0288086 0.737243 0 2.57825 0 22.5572V44.3454L0.467453 44.6726C0.882967 44.9638 3.32643 45 22.5469 45C43.8786 45 44.1643 44.9945 44.5794 44.5794C44.9725 44.1864 45 43.8786 45 39.8807C45 36.0032 44.964 35.57 44.6154 35.2546C44.1353 34.8201 43.859 34.8159 43.4378 35.2369C43.1621 35.5128 43.1075 36.1905 43.1075 39.3374V43.1075H31.1215H19.1355V40.2761C19.1355 37.66 19.1036 37.4276 18.715 37.2196C18.4161 37.0598 18.1726 37.0598 17.8738 37.2196C17.4852 37.4276 17.4533 37.66 17.4533 40.2761V43.1075H9.6729H1.89252V33.2243V23.3411H9.6729H17.4533L17.4564 24.34C17.4606 25.609 17.6596 25.9158 18.4225 25.8287L19.0304 25.7593V22.5V19.2407H18.2944H17.5584L17.4953 20.4498L17.4322 21.6589H9.66238H1.89252V11.7757V1.89252H9.66596H17.4394L17.4989 4.23568C17.5487 6.1978 17.6183 6.61668 17.9264 6.81056C18.1943 6.97921 18.3945 6.97921 18.6624 6.81056C18.9704 6.61668 19.04 6.1978 19.0899 4.23568L19.1494 1.89252H31.1284H43.1075V9.88591V17.8793L35.8002 17.824L28.493 17.7687L28.4333 15.6331C28.366 13.2241 28.1498 12.7909 27.225 13.2123C26.7104 13.4468 26.7056 13.4752 26.7056 16.2503C26.7056 18.1485 26.787 19.1328 26.9579 19.3037C27.1453 19.4911 29.2569 19.5561 35.1589 19.5561H43.1075V22.2748C43.1075 24.4657 43.1716 25.0574 43.4378 25.3239C43.8712 25.757 44.2253 25.7413 44.652 25.2696C44.9672 24.9214 45 23.7579 45 12.91C45 2.41171 44.9596 0.877079 44.6726 0.467453L44.3454 0H22.5206C1.64439 0 0.680888 0.0166122 0.348014 0.384603ZM17.8213 9.68972C17.4979 9.87813 17.4533 10.2695 17.4533 12.9169C17.4533 16.16 17.5624 16.5049 18.5457 16.3655C19.0241 16.2976 19.0312 16.2559 19.0888 13.144C19.1404 10.3637 19.1046 9.96014 18.7858 9.72694C18.3568 9.41341 18.2997 9.4111 17.8213 9.68972ZM37.3016 26.4072C37.1898 26.8532 37.3204 27.1077 38.0336 27.8346C38.5112 28.3212 38.9019 28.7844 38.9019 28.8639C38.9019 28.9436 37.2798 29.0347 35.2972 29.0662C32.1311 29.1169 31.6642 29.1686 31.4607 29.4918C31.2916 29.7599 31.2916 29.9597 31.4607 30.2278C31.6642 30.551 32.1311 30.6027 35.2972 30.6534C37.2798 30.685 38.9019 30.784 38.9019 30.8736C38.9019 30.9629 38.5234 31.4058 38.0607 31.8575C37.1921 32.7057 37.0363 33.1671 37.472 33.6028C38.0166 34.1474 38.6153 33.8356 40.3259 32.1159C41.5678 30.8675 42.0561 30.2282 42.0561 29.8508C42.0561 29.0769 38.7936 25.8645 38.0078 25.8645C37.5706 25.8645 37.4061 25.9909 37.3016 26.4072ZM17.6831 28.4694C17.5199 28.6661 17.46 29.6733 17.4995 31.5486C17.55 33.9344 17.6114 34.3691 17.9264 34.5676C18.1945 34.7362 18.3943 34.7362 18.6624 34.5676C18.9774 34.3691 19.0388 33.9344 19.0893 31.5486C19.15 28.6658 19.035 28.1776 18.2944 28.1776C18.0915 28.1776 17.8162 28.309 17.6831 28.4694Z"
				fill="#A7A7A7"
			/>
		</svg>
	),
	KitchenArea: (props: React.SVGProps<SVGSVGElement>, className?: string) => (
		<svg
			width="47"
			height="47"
			{...props}
			className={className ? className : ""}
			viewBox="0 0 47 47"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M21.8354 0.220754C21.2791 0.525115 20.9542 0.982634 20.9542 1.46189C20.9542 1.7545 20.7094 1.99404 20.1156 2.28253C18.2897 3.16976 17.2091 4.55897 16.8137 6.52752C16.6155 7.51463 16.63 7.68248 16.9423 8.02758C17.2277 8.3431 17.5561 8.4187 18.6835 8.4283L20.0729 8.44025L20.6604 9.24404C21.6658 10.6195 23.3811 11.2206 25.0326 10.7758C25.9229 10.5361 27.3197 9.42227 27.5195 8.79279C27.6231 8.4663 27.8303 8.41635 29.0805 8.41635C30.917 8.41635 31.2319 8.16507 31.0733 6.826C30.8584 5.01159 29.6409 3.28355 27.9785 2.43373C27.3554 2.11527 27.0313 1.80915 26.9426 1.45524C26.8715 1.17183 26.6004 0.727434 26.3406 0.467337C25.9076 0.0342992 25.7149 -0.00487201 24.0474 0.000416108C23.0463 0.00374566 22.0508 0.102849 21.8354 0.220754ZM23.1573 1.70397C23.5613 1.74628 24.2222 1.74628 24.626 1.70397C25.03 1.66186 24.6995 1.6272 23.8917 1.6272C23.0839 1.6272 22.7535 1.66186 23.1573 1.70397ZM21.6396 3.50722C20.2343 3.84938 19.2285 4.67824 18.7087 5.92193L18.403 6.65365H23.9022H29.4014L29.2646 6.21297C28.8766 4.96302 27.5925 3.82803 26.2378 3.53738C25.1378 3.30157 22.5543 3.28453 21.6396 3.50722ZM22.4936 8.81453C23.0604 9.28693 24.4429 9.32982 25.2723 8.9009C25.5899 8.73658 25.85 8.56031 25.85 8.50919C25.85 8.45807 24.9909 8.41929 23.9406 8.42282L22.0312 8.42947L22.4936 8.81453ZM4.30833 22.1263H6.04714H11.7383H17.4292H18.9958H23.5H28.0042C28.0075 22.0266 29.0489 22.0843 29.5708 22.1263H35.2617H40.9529H42.6917H44.3435C45.252 22.1263 46.2214 22.2123 46.4977 22.3172L47 22.5082V25.3138C47 28.3993 46.9352 28.5895 45.8838 28.5895H45.2375V37.416C45.2375 43.1256 45.1658 46.376 45.0348 46.6212C44.8362 46.9922 44.3899 47 23.5 47C2.61007 47 2.16376 46.9922 1.96519 46.6212C1.83417 46.376 1.7625 43.1256 1.7625 37.416V28.5895H1.11625C0.0648209 28.5895 0 28.3993 0 25.3138V22.5082L0.502312 22.3172C0.778633 22.2123 1.74801 22.1263 2.65648 22.1263H4.30833ZM1.56667 25.3579V26.8268H23.5H45.4333V25.3579V23.889H23.5H1.56667V25.3579ZM3.525 37.0113V45.4332H23.5H43.475V37.0113V28.5895H23.5H3.525V37.0113ZM5.79099 30.2682C5.52387 30.5356 5.48333 31.42 5.48333 36.9861C5.48333 41.7107 5.54522 43.4581 5.71833 43.6313C6.05575 43.9687 21.1651 43.9687 21.5025 43.6313C21.6756 43.4581 21.7375 41.7142 21.7375 37.0025C21.7375 31.0571 21.7124 30.5861 21.3793 30.2847C21.0593 29.995 20.228 29.9605 13.5601 29.9605C7.03825 29.9605 6.06006 29.9993 5.79099 30.2682ZM25.5866 30.3187C25.2991 30.6364 25.2625 31.3936 25.2625 37.0366C25.2625 41.7219 25.3244 43.4581 25.4975 43.6313C25.8349 43.9687 40.9442 43.9687 41.2817 43.6313C41.4548 43.4581 41.5167 41.7107 41.5167 36.9861C41.5167 31.42 41.4761 30.5356 41.209 30.2682C40.9399 29.9993 39.9586 29.9605 33.406 29.9605C26.3934 29.9605 25.8898 29.9836 25.5866 30.3187ZM7.0925 33.9266L7.14792 36.13L13.5615 36.1817L19.975 36.2332V33.9783V31.7232H13.506H7.03708L7.0925 33.9266ZM27.025 37.0113V42.2995H33.4875H39.95V37.0113V31.7232H33.4875H27.025V37.0113ZM12.0577 33.4019C11.6852 33.7746 11.6773 33.8992 11.9991 34.3393C12.2047 34.6207 12.5032 34.6699 13.7126 34.6215C15.0723 34.5673 15.1816 34.5308 15.2411 34.1117C15.3504 33.341 14.9525 33.0942 13.6004 33.0942C12.7388 33.0942 12.2725 33.1873 12.0577 33.4019ZM28.2392 35.2878C27.8745 35.6525 27.9311 38.2815 28.3118 38.6622C28.6761 39.0263 28.7021 39.0294 29.1921 38.7672C29.5166 38.5935 29.5708 38.3467 29.5708 37.0437C29.5708 35.4995 29.395 35.0528 28.7875 35.0528C28.6152 35.0528 28.3684 35.1585 28.2392 35.2878ZM7.05 40.0471V42.2995H13.5125H19.975V40.0471V37.7948H13.5125H7.05V40.0471ZM12.1961 39.4106C11.7649 39.9684 11.7549 40.1499 12.1346 40.5297C12.5795 40.9747 14.2142 41.0908 14.8963 40.7257C15.3197 40.4991 15.3997 39.7606 15.04 39.4008C14.7233 39.0841 12.4425 39.0919 12.1961 39.4106Z"
				fill="#A7A7A7"
			/>
		</svg>
	),
	Calendar: (props: React.SVGProps<SVGSVGElement>, className?: string) => (
		<svg
			width="59"
			height="59"
			{...props}
			className={className ? className : ""}
			viewBox="0 0 59 59"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M49 24.7222V17.5556C49 14.9169 46.8175 12.7778 44.125 12.7778H14.875C12.1826 12.7778 10 14.9169 10 17.5556V24.7222M49 24.7222H10M49 24.7222V28.9028M10 24.7222V46.2222C10 48.861 12.1826 51 14.875 51H27.0625M19.75 8V17.5556M39.25 8V17.5556"
				stroke="#A7A7A7"
				strokeWidth="2.4"
				strokeLinecap="round"
			/>
			<path
				d="M34.417 46.708L39.3337 51.6247L51.6253 39.333"
				stroke="#A7A7A7"
				strokeWidth="2.4"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	),
	Ladder: (props: React.SVGProps<SVGSVGElement>, className?: string) => (
		<svg
			width="43"
			height="43"
			{...props}
			className={className ? className : ""}
			viewBox="0 0 43 43"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M24.8723 0.329386C24.2535 0.610613 12.4754 10.2291 10.7093 11.8953C10.3462 12.2378 10.0806 12.6473 10.0806 12.8646C10.0806 13.2382 10.6369 13.7635 11.0324 13.7635C11.209 13.7635 14.3953 11.1556 23.2423 3.76943C24.2567 2.92256 25.2752 2.1237 25.5058 1.99425C25.8434 1.80453 27.3486 1.74912 33.252 1.70866C40.4475 1.65947 40.5855 1.66484 40.9227 2.00248C41.3514 2.43179 41.3528 2.59566 40.9309 3.01809C40.606 3.34348 40.3721 3.35389 33.3924 3.35389H26.1892L14.7397 12.8663C8.44251 18.0981 3.16359 22.487 3.00883 22.6194C2.40993 23.1318 1.44167 22.292 1.89453 21.6528C2.01659 21.4806 3.71973 20.0064 5.6794 18.3768C8.71715 15.8508 9.24227 15.347 9.24227 14.9583C9.24227 14.3861 8.96278 14.0983 8.41233 14.103C7.8857 14.1077 0.659176 20.0657 0.272876 20.8139C-0.595963 22.4964 0.722553 24.5795 2.63812 24.5504L3.374 24.5393V27.7747V31.0101L2.49611 31.1143C1.51863 31.2302 0.959296 31.5725 0.397954 32.3984C-0.0884416 33.114 -0.107388 34.2864 0.355199 35.046C0.737643 35.6743 1.60715 36.2602 2.15843 36.2611L2.53568 36.2617V39.4182C2.53568 41.6494 2.5947 42.6338 2.73688 42.7762C3.05008 43.0898 42.4929 43.0665 42.7531 42.7525C42.8849 42.5935 42.9526 39.3643 42.9833 31.7693C43.0239 21.7099 43.0078 20.9995 42.7357 20.8293C42.35 20.5882 41.7179 20.5979 41.4674 20.8488C41.3154 21.0011 41.2663 23.5239 41.2663 31.1745V41.2987H40.0088H38.7513H36.907H32.7992H28.6914L26.8471 41.301L15.5716 41.2579L4.29616 41.2147L4.24972 38.7382L4.20344 36.2617V34.408C2.09539 34.3893 1.99404 34.3205 1.85899 34.0678C1.71479 33.7979 1.7329 33.63 1.94081 33.3123L2.20806 32.9038H7.23415H12.2602H14.103C14.1041 32.6605 14.1046 32.3968 14.1046 32.1108V28.7064V26.8262C13.0297 26.7956 12.5453 26.742 12.4614 26.658C12.2027 26.399 12.2027 25.809 12.4614 25.5499C12.609 25.4022 13.9966 25.3484 17.659 25.3484H22.6555H24.4988C24.4995 25.1239 24.4998 24.8821 24.4998 24.6216V21.151V19.3022C21.5629 19.293 21.4567 19.2411 21.2524 18.949C21.0006 18.589 21.0581 18.1461 21.3857 17.9215C21.4847 17.8537 23.8102 17.7971 26.5537 17.7956L31.5417 17.793H33.3854C33.3858 17.5613 33.386 17.3101 33.386 17.0375V13.5956V11.7369C31.5474 11.7136 31.1308 11.6491 30.9668 11.485C30.6531 11.1707 30.6261 10.718 30.9046 10.4391C31.0523 10.2912 32.4583 10.2377 36.186 10.2377H41.2663V10.9932V11.7487V13.5956V16.0805C41.2663 17.7894 41.3291 18.6283 41.4674 18.7669C41.7268 19.0266 42.4823 19.0266 42.7417 18.7669C43.0289 18.4792 43.0289 8.87989 42.7417 8.59228C42.5958 8.44621 41.3742 8.3908 38.2986 8.3908H34.0567V6.81039V5.23014L37.5357 5.17339C40.6836 5.12218 41.0706 5.0839 41.6011 4.77195C43.3399 3.74895 43.4088 1.35658 41.7288 0.330897C41.204 0.0103809 40.8734 -0.00271513 33.386 0.000307024C26.029 0.00316128 25.5492 0.02163 24.8723 0.329386ZM25.5477 6.22476L24.3321 7.24222V11.5943V15.9462H27.9369H31.5417V14.7842C31.5417 13.6492 31.531 13.62 31.0739 13.5194C29.1417 13.0944 28.269 10.8292 29.4816 9.38627C30.0475 8.71283 30.7113 8.3908 31.5333 8.3908H32.2124V6.79578V5.20076L29.4878 5.20395L26.7632 5.20714L25.5477 6.22476ZM19.0922 11.607L15.6135 14.4873V18.9945V23.5016H19.1345H22.6555V22.3263V21.151H22.0378C21.18 21.151 20.0511 20.562 19.6439 19.902C19.1939 19.1728 19.188 17.8985 19.6316 17.1702C20.0432 16.494 21.0937 15.9462 21.9781 15.9462H22.6555V12.3364C22.6555 10.351 22.6365 8.7266 22.6132 8.7266C22.5899 8.7266 21.0055 10.0228 19.0922 11.607ZM9.3987 19.6819L5.13448 23.2497L5.08955 27.1533L5.04445 31.0569H8.65243H12.2602V29.8358C12.2602 28.6221 12.2569 28.613 11.6964 28.3108C10.5107 27.6713 10.0565 25.927 10.7932 24.8431C11.3614 24.0069 11.974 23.6315 12.9185 23.5407L13.7692 23.4589V19.7865C13.7692 17.7667 13.7452 16.1141 13.7161 16.1141C13.6867 16.1141 11.744 17.7197 9.3987 19.6819ZM0.0710076 21.9905C0.0710076 22.4984 0.102361 22.7061 0.140756 22.4522C0.179151 22.1983 0.179151 21.7826 0.140756 21.5288C0.102361 21.2747 0.0710076 21.4826 0.0710076 21.9905ZM0.0710076 33.7433C0.0710076 34.2512 0.102361 34.4589 0.140756 34.205C0.179151 33.9511 0.179151 33.5354 0.140756 33.2816C0.102361 33.0277 0.0710076 33.2354 0.0710076 33.7433Z"
				fill="#A7A7A7"
			/>
		</svg>
	),
	CheckMark: (props: React.SVGProps<SVGSVGElement>, className?: string) => (
		<svg
			width="12"
			height="9"
			{...props}
			className={className ? className : ""}
			viewBox="0 0 12 9"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M10.9306 0.403157C10.5045 -0.0229184 9.81384 -0.0228568 9.38783 0.403114L4.00774 5.78325L2.20355 3.97906C1.77749 3.55298 1.08682 3.55315 0.660846 3.97904C0.234782 4.40506 0.234816 5.09576 0.660828 5.52177L3.23639 8.09729C3.6625 8.52346 4.35341 8.52299 4.77911 8.09729L10.9305 1.94586C11.3566 1.51981 11.3565 0.829129 10.9306 0.403157ZM1.26412 4.29553C1.20037 4.31904 1.14056 4.3564 1.08936 4.40759C0.90001 4.59692 0.90001 4.90388 1.08936 5.09323L3.66492 7.66875C3.80334 7.80722 4.00483 7.84435 4.17711 7.7803C4.0051 7.84372 3.80424 7.80643 3.66614 7.6683L1.09058 5.09278C0.901235 4.90343 0.901235 4.59647 1.09058 4.40714C1.14146 4.35627 1.20083 4.31907 1.26412 4.29553ZM9.9911 0.719604C9.92735 0.743115 9.86754 0.780471 9.81634 0.831671L4.00859 6.63948L4.00897 6.63986L9.81756 0.831216C9.86844 0.780344 9.9278 0.743141 9.9911 0.719604Z"
				fill="white"
			/>
		</svg>
	),
	NoShow: (props: React.SVGProps<SVGSVGElement>, className?: string) => (
		<svg
			width="24"
			height="24"
			{...props}
			className={className ? className : ""}
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M10.7429 5.09232C11.1494 5.03223 11.5686 5 12.0004 5C17.1054 5 20.4553 9.50484 21.5807 11.2868C21.7169 11.5025 21.785 11.6103 21.8231 11.7767C21.8518 11.9016 21.8517 12.0987 21.8231 12.2236C21.7849 12.3899 21.7164 12.4985 21.5792 12.7156C21.2793 13.1901 20.8222 13.8571 20.2165 14.5805M6.72432 6.71504C4.56225 8.1817 3.09445 10.2194 2.42111 11.2853C2.28428 11.5019 2.21587 11.6102 2.17774 11.7765C2.1491 11.9014 2.14909 12.0984 2.17771 12.2234C2.21583 12.3897 2.28393 12.4975 2.42013 12.7132C3.54554 14.4952 6.89541 19 12.0004 19C14.0588 19 15.8319 18.2676 17.2888 17.2766M3.00042 3L21.0004 21M9.8791 9.87868C9.3362 10.4216 9.00042 11.1716 9.00042 12C9.00042 13.6569 10.3436 15 12.0004 15C12.8288 15 13.5788 14.6642 14.1217 14.1213"
				stroke="#878787"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	),
	Show: (props: React.SVGProps<SVGSVGElement>, className?: string) => (
		<svg
			width="24"
			height="24"
			{...props}
			className={className ? className : ""}
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M2.42012 12.7132C2.28394 12.4975 2.21584 12.3897 2.17772 12.2234C2.14909 12.0985 2.14909 11.9015 2.17772 11.7766C2.21584 11.6103 2.28394 11.5025 2.42012 11.2868C3.54553 9.50484 6.8954 5 12.0004 5C17.1054 5 20.4553 9.50484 21.5807 11.2868C21.7169 11.5025 21.785 11.6103 21.8231 11.7766C21.8517 11.9015 21.8517 12.0985 21.8231 12.2234C21.785 12.3897 21.7169 12.4975 21.5807 12.7132C20.4553 14.4952 17.1054 19 12.0004 19C6.8954 19 3.54553 14.4952 2.42012 12.7132Z"
				stroke="#878787"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M12.0004 15C13.6573 15 15.0004 13.6569 15.0004 12C15.0004 10.3431 13.6573 9 12.0004 9C10.3435 9 9.0004 10.3431 9.0004 12C9.0004 13.6569 10.3435 15 12.0004 15Z"
				stroke="#878787"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	),
	Download: (props: React.SVGProps<SVGSVGElement>, className?: string) => (
		<svg
			width="25"
			height="24"
			{...props}
			className={className ? className : ""}
			viewBox="0 0 25 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M21.5 21H3.5M18.5 11L12.5 17M12.5 17L6.5 11M12.5 17V3"
				stroke="#878787"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	),
	Mark: (props: React.SVGProps<SVGSVGElement>, className?: string) => (
		<svg
			width="20"
			height="20"
			viewBox="0 0 20 20"
			{...props}
			className={className ? className : ""}
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M16.2796 6.27083C16.5212 6.0243 16.5172 5.62859 16.2706 5.38699C16.0241 5.14539 15.6284 5.14939 15.3868 5.39592L8.41048 12.5146C8.00205 12.9314 7.33096 12.9314 6.92253 12.5146L4.61289 10.1578C4.37129 9.91129 3.97558 9.9073 3.72905 10.1489C3.48252 10.3905 3.47852 10.7862 3.72012 11.0327L6.02977 13.3895C6.92831 14.3064 8.40469 14.3064 9.30324 13.3895L16.2796 6.27083Z"
				fill="#0468FF"
			/>
		</svg>
	),
	Pencil: (props: React.SVGProps<SVGSVGElement>, className?: string) => (
		<svg
			width="24"
			height="24"
			{...props}
			className={className ? className : ""}
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M18 10.0001L14 6.00006M2.5 21.5001L5.88437 21.124C6.29786 21.0781 6.5046 21.0551 6.69785 20.9925C6.86929 20.937 7.03245 20.8586 7.18289 20.7594C7.35245 20.6476 7.49955 20.5005 7.79373 20.2063L21 7.00006C22.1046 5.89549 22.1046 4.10463 21 3.00006C19.8955 1.89549 18.1046 1.89549 17 3.00006L3.79373 16.2063C3.49955 16.5005 3.35246 16.6476 3.24064 16.8172C3.14143 16.9676 3.06301 17.1308 3.00751 17.3022C2.94496 17.4955 2.92198 17.7022 2.87604 18.1157L2.5 21.5001Z"
				stroke="#878787"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	),
	ArrowArchive: (props: React.SVGProps<SVGSVGElement>, className?: string) => (
		<svg
			width="24"
			height="24"
			{...props}
			className={className ? className : ""}
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				fill-rule="evenodd"
				clip-rule="evenodd"
				d="M21.5668 5.50277C21.5668 4.12205 20.4475 3.00277 19.0668 3.00277H4.60681C3.33819 2.94332 2.22811 3.84817 2.03057 5.10272C1.83302 6.35728 2.61131 7.55948 3.83681 7.89277V16.8928C3.8368 18.7445 5.33504 20.2473 7.18681 20.2528H16.4668C17.3597 20.2554 18.2169 19.9026 18.8492 19.2722C19.4814 18.6418 19.8368 17.7856 19.8368 16.8928V7.89277C20.8742 7.5603 21.575 6.59209 21.5668 5.50277ZM16.4768 18.7428H7.19681C6.70616 18.7428 6.23561 18.5479 5.88866 18.2009C5.54172 17.854 5.34681 17.3834 5.34681 16.8928V8.00277H18.3468V16.8928C18.3468 17.3869 18.1492 17.8605 17.7979 18.208C17.4466 18.5556 16.9709 18.7481 16.4768 18.7428ZM4.60681 6.50277H19.0668C19.6191 6.50277 20.0668 6.05505 20.0668 5.50277C20.0668 4.95048 19.6191 4.50277 19.0668 4.50277H4.60681C4.05453 4.50277 3.60681 4.95048 3.60681 5.50277C3.60681 6.05505 4.05453 6.50277 4.60681 6.50277Z"
				fill="#878787"
			/>
			<path
				d="M14.0868 10.6328H9.58681C9.1726 10.6328 8.83681 10.9686 8.83681 11.3828C8.83681 11.797 9.1726 12.1328 9.58681 12.1328H14.0868C14.501 12.1328 14.8368 11.797 14.8368 11.3828C14.8368 10.9686 14.501 10.6328 14.0868 10.6328Z"
				fill="#878787"
			/>
		</svg>
	),
	Filter: (props: React.SVGProps<SVGSVGElement>, className?: string) => (
		<svg
			width="24"
			height="24"
			{...props}
			className={className ? className : ""}
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M3 8L15 8M15 8C15 9.65686 16.3431 11 18 11C19.6569 11 21 9.65685 21 8C21 6.34315 19.6569 5 18 5C16.3431 5 15 6.34315 15 8ZM9 16L21 16M9 16C9 17.6569 7.65685 19 6 19C4.34315 19 3 17.6569 3 16C3 14.3431 4.34315 13 6 13C7.65685 13 9 14.3431 9 16Z"
				stroke="#878787"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	),
	Maps: (props: React.SVGProps<SVGSVGElement>, className?: string) => (
		<svg
			width="24"
			height="24"
			{...props}
			className={className ? className : ""}
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M4.5 7.99927V17.3393C4.5 18.3443 5.73349 18.8265 6.4151 18.0881L6.96621 18.5968L7.51731 19.1055C5.90952 20.8473 3 19.7097 3 17.3393V7.99927C3 7.055 3.44458 6.16584 4.2 5.59927L7.51672 3.11174C8.42577 2.42995 9.64201 2.32028 10.6584 2.82845L14.3081 4.65332C15.327 5.16279 16.5546 4.99086 17.3944 4.22107C19.1572 2.60513 22 3.85567 22 6.24708V15.5942C22 16.4845 21.6045 17.3288 20.9206 17.8988L17.6911 20.59C16.6846 21.4287 15.2503 21.5173 14.1483 20.8089L10.8388 18.6813C9.77544 17.9978 8.37473 18.1766 7.51731 19.1055L6.96621 18.5968L6.4151 18.0881C6.92851 17.5319 7.56552 17.1463 8.25 16.9411V4.43677L5.1 6.79927C4.72229 7.08256 4.5 7.52714 4.5 7.99927ZM11.6499 17.4196C11.0621 17.0417 10.4088 16.831 9.75 16.78V4.07563C9.83089 4.10005 9.91037 4.13151 9.98754 4.1701L13.6373 5.99496C14.1512 6.25192 14.6994 6.39674 15.25 6.43391V19.6922C15.1496 19.6551 15.0522 19.6067 14.9594 19.5471L11.6499 17.4196ZM16.75 19.4217L19.9603 16.7465C20.3023 16.4615 20.5 16.0393 20.5 15.5942V6.24708C20.5 5.16083 19.2087 4.59279 18.408 5.3268C17.923 5.77139 17.3543 6.08697 16.75 6.2668V19.4217Z"
				fill="#878787"
			/>
		</svg>
	),
	Menu: (props: React.SVGProps<SVGSVGElement>, className?: string) => (
		<svg
			width="24"
			height="24"
			{...props}
			className={className ? className : ""}
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M3 12H21M3 6H21M3 18H21"
				stroke="#2D2D2D"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	),
	Search: (props: React.SVGProps<SVGSVGElement>, className?: string) => (
		<svg
			width="24"
			height="24"
			{...props}
			className={className ? className : ""}
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M21 21L16.65 16.65M19 11C19 15.4183 15.4183 19 11 19C6.58172 19 3 15.4183 3 11C3 6.58172 6.58172 3 11 3C15.4183 3 19 6.58172 19 11Z"
				stroke="#2D2D2D"
				strokeWidth="2"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
		</svg>
	),
	Profile: (props: React.SVGProps<SVGSVGElement>, className?: string) => (
		<svg
			width="24"
			height="24"
			{...props}
			className={className ? className : ""}
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M3 20C5.33579 17.5226 8.50702 16 12 16C15.493 16 18.6642 17.5226 21 20M16.5 7.5C16.5 9.98528 14.4853 12 12 12C9.51472 12 7.5 9.98528 7.5 7.5C7.5 5.01472 9.51472 3 12 3C14.4853 3 16.5 5.01472 16.5 7.5Z"
				stroke="#2D2D2D"
				strokeWidth="1.5"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
		</svg>
	),
	Ads: (props: React.SVGProps<SVGSVGElement>, className?: string) => (
		<svg
			width="24"
			height="24"
			{...props}
			className={className ? className : ""}
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M14 11H8M10 15H8M16 7H8M20 6.8V17.2C20 18.8802 20 19.7202 19.673 20.362C19.3854 20.9265 18.9265 21.3854 18.362 21.673C17.7202 22 16.8802 22 15.2 22H8.8C7.11984 22 6.27976 22 5.63803 21.673C5.07354 21.3854 4.6146 20.9265 4.32698 20.362C4 19.7202 4 18.8802 4 17.2V6.8C4 5.11984 4 4.27976 4.32698 3.63803C4.6146 3.07354 5.07354 2.6146 5.63803 2.32698C6.27976 2 7.11984 2 8.8 2H15.2C16.8802 2 17.7202 2 18.362 2.32698C18.9265 2.6146 19.3854 3.07354 19.673 3.63803C20 4.27976 20 5.11984 20 6.8Z"
				stroke="#2D2D2D"
				strokeWidth="1.5"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
		</svg>
	),
	Archive: (props: React.SVGProps<SVGSVGElement>, className?: string) => (
		<svg
			width="24"
			height="24"
			{...props}
			className={className ? className : ""}
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				fill-rule="evenodd"
				clip-rule="evenodd"
				d="M21.5668 5.50277C21.5668 4.12205 20.4475 3.00277 19.0668 3.00277H4.60681C3.33819 2.94332 2.22811 3.84817 2.03057 5.10272C1.83302 6.35728 2.61131 7.55948 3.83681 7.89277V16.8928C3.8368 18.7445 5.33504 20.2473 7.18681 20.2528H16.4668C17.3597 20.2554 18.2169 19.9026 18.8492 19.2722C19.4814 18.6418 19.8368 17.7856 19.8368 16.8928V7.89277C20.8742 7.5603 21.575 6.59209 21.5668 5.50277ZM16.4768 18.7428H7.19681C6.70616 18.7428 6.23561 18.5479 5.88866 18.2009C5.54172 17.854 5.34681 17.3834 5.34681 16.8928V8.00277H18.3468V16.8928C18.3468 17.3869 18.1492 17.8605 17.7979 18.208C17.4466 18.5556 16.9709 18.7481 16.4768 18.7428ZM4.60681 6.50277H19.0668C19.6191 6.50277 20.0668 6.05505 20.0668 5.50277C20.0668 4.95048 19.6191 4.50277 19.0668 4.50277H4.60681C4.05453 4.50277 3.60681 4.95048 3.60681 5.50277C3.60681 6.05505 4.05453 6.50277 4.60681 6.50277Z"
				fill="#2D2D2D"
			/>
			<path
				d="M14.0868 10.6328H9.58681C9.1726 10.6328 8.83681 10.9686 8.83681 11.3828C8.83681 11.797 9.1726 12.1328 9.58681 12.1328H14.0868C14.501 12.1328 14.8368 11.797 14.8368 11.3828C14.8368 10.9686 14.501 10.6328 14.0868 10.6328Z"
				fill="#2D2D2D"
			/>
		</svg>
	),
};
